import axios from './index';

export const fetchBankCardById = async (id) => {
  const { data } = await axios.get(`/bank-cards/${id}/admin`);
  return data.data;
};

export const fetchBankCardList = async (page, limit, filters = {}, sort = undefined) => {
  const { data } = await axios.get(`/bank-cards/admin`, { params: { page, limit, sort, ...filters } });
  return data.data;
};

export const fetchBankCardBalances = async (page, limit, cardId) => {
  const { data } = await axios.get(`/bank-cards/${cardId}/balances/admin`, { params: { page, limit } });
  return data.data;
};

export const createBankCard = async (payload) => {
  const { data } = await axios.post(`/bank-cards/admin`, payload);
  return data;
};

export const updateBankCard = async (id, payload) => {
  const { data } = await axios.put(`/bank-cards/admin`, { id, ...payload });
  return data.messages;
};

export const resetPinCode = async (id) => {
  const { data } = await axios.post(`/bank-cards/${id}/reset-pin/admin`);
  return data;
};

export const transferCardToAccount = async (id) => {
  const { data } = await axios.put(`/bank-cards/${id}/transfer-to-account/admin`);
  return data.messages;
};

export const addPendingBankCard = async (payload) => {
  const { data } = await axios.post(`/bank-cards/add-pending/admin`, payload);
  return data.messages;
};

export const deleteBankCard = async (id) => {
  const { data } = await axios.delete(`/bank-cards/${id}/admin`);
  return data.messages;
};

export const softDeleteBankCard = async (id) => {
  const { data } = await axios.delete(`/bank-cards/${id}/soft/admin`);
  return data.messages;
};

// ------------------------------------------------

export const fetchBankCardProductionList = async () => {
  const { data } = await axios.get(`/bank-cards/productions/admin`);
  return data.data;
};

export const updateBankCardProduction = async (id, payload) => {
  const { data } = await axios.put(`/bank-cards/productions/${id}/admin`, payload);
  return data.messages;
};

// ------------------------------------------------

export const fetchBankCardCodeReceiver = async (type) => {
  const { data } = await axios.get(`/bank-cards/code-receiver/${type}`);
  return data.data;
};

// ------------------------------------------------

export const fetchSumArchiveBalance = async (tokenNumber = 2) => {
  const { data } = await axios.get(`/bank-cards/archive/balance/${tokenNumber}/admin`);
  return data.data;
};

export const fetchBankCardTransactions = async (page, limit, cardId) => {
  const { data } = await axios.get(`/bank-cards/${cardId}/transactions/admin`, { params: { page, limit } });
  return data.data;
};

export const fetchStats = async () => {
  const { data } = await axios.get(`/bank-cards/get-stats`);
  return data.data;
};

export const fetchOfflineRequests = async () => {
  const { data } = await axios.get(`/bank-cards/offline/pending`);
  return data.data;
};

export const getKycPending = async () => {
  const { data } = await axios.get(`/bank-cards/virtual/kyc`);
  return data.data;
};

export const getAddressPending = async () => {
  const { data } = await axios.get(`/bank-cards/virtual/address`);
  return data.data;
};

export const confirmOfflineCardRequest = async (payload) => {
  const { data } = await axios.put(`/bank-cards/offline/confirm`, payload);
  return data.messages;
};

export const confirmOfflineChargeRequest = async (payload) => {
  const { data } = await axios.put(`/bank-cards/offline/charge/confirm`, payload);
  return data.messages;
};

export const rejectOfflineCardRequest = async (id) => {
  const { data } = await axios.get(`/bank-cards/offline/reject/${id}`);
  return data.messages;
};

export const rejectOfflineChargeRequest = async (id) => {
  const { data } = await axios.get(`/bank-cards/offline/charge/reject/${id}`);
  return data.messages;
};
export const addKyc = async (payload) => {
  const { data } = await axios.post(`/bank-cards/virtual/kyc`, payload);
  return data.messages;
};
export const setMobile = async (payload) => {
  const { data } = await axios.post(`/bank-cards/virtual/mobile`, payload);
  return data;
};
export const setAddress = async (payload) => {
  const { data } = await axios.post(`/bank-cards/virtual/address`, payload);
  return data.messages;
};

export const getQrcode = async (payload) => {
  console.log(payload);

  const { data } = await axios.post(`/bank-cards/virtual/qr-code`, payload);
  return data;
};
export const getAccountDetails = async () => {
  const { data } = await axios.get(`/bank-cards/virtual/account-details`);
  return data;
};

export const fetchChainTypes = async (payType, token) => {
  const { data } = await axios.get(`/bank-cards/virtual/chain-types`, { params: { payType, token } });
  return data;
};

export const rechargeAccount = async (amount) => {
  const { data } = await axios.post(`/bank-cards/virtual/recharge-aegpay`, { amount });
  return data;
};

export const withDrawFromCard = async (token) => {
  const { data } = await axios.post(`/bank-cards/virtual/withdraw-aegpay`, { token });
  return data.messages;
};

export const getUserCards = async () => {
  const { data } = await axios.get(`/bank-cards/virtual/user-card`);
  return data.data;
};

export const getAegpayBalance = async () => {
  const { data } = await axios.get(`/bank-cards/virtual/aegpay-balance`);
  return data.data;
};

export const getUserAddress = async (id) => {
  console.log('api', id);

  const { data } = await axios.get(`/bank-cards/virtual/user-address/?id=${id}`);
  return data.data;
};

export const orderPayment = async () => {
  const { data } = await axios.get(`/bank-cards/virtual/admin-purchase`);
  return data.data;
};
